import retryingDynamicImport from 'retrying-dynamic-import'

// Installs the global __retrying_dynamic_loader__ that every import() in the bundle calls.
// The vite-plugin-retrying-dynamic-import build plugin rewrites EVERY import() to
// __retrying_dynamic_loader__(() => import(...)), so the loader must exist before any
// module's top-level code runs. This file is imported FIRST in main.ts: ES modules are
// evaluated in source order, so installing here runs before sibling imports evaluate —
// guarding against a hard crash if any eagerly-evaluated module fires a dynamic import()
// at eval time (before the loader would otherwise be installed).
//
// Cache-busting retry for transient dynamic-import (chunk-load) failures: the runtime
// re-requests a failed chunk with a ?t=<ts> query — the only thing that forces a real
// re-fetch (a same-URL re-import returns the browser's cached module-map failure). Tuned
// low so the last-resort router.onError reload (src/router/index.js) is not delayed for
// genuinely-broken chunks. disableRetryingCSS: Vite's __vitePreload wrapper (which sits
// OUTSIDE our loader) already loads each chunk's CSS deps, so the runtime's per-call CSS
// re-scan is redundant and would risk fighting our viteAsyncCssPlugin.
retryingDynamicImport({
	maxRetries: 2,
	interval: 250,
	disableRetryingCSS: true,
})
